import {
  forwardRef,
  type MutableRefObject,
  type ReactNode,
  useMemo,
} from 'react';

import {
  datapointCanvasPlot,
  rectangleCanvasPlot,
} from './XYChartLayout.sty.js';
import { Canvas, type CanvasRef } from '../../core/components/canvas/Canvas.js';
import { CanvasContext } from '../../core/components/canvas/CanvasContext.js';
import type { CanvasShape } from '../../core/components/canvas/types/canvas-shape.js';
import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { POINT_OVERLAY_PADDING } from '../../core/components/data-point/constants.js';

interface XYChartCanvasPlotProps {
  children: ReactNode;
  shifted?: boolean;
}

export const XYChartCanvasPlot = forwardRef<CanvasRef, XYChartCanvasPlotProps>(
  ({ shifted, children }, canvasRefs) => {
    const { height, width } = useGridPlotSize();
    const plotStyles = shifted ? datapointCanvasPlot : rectangleCanvasPlot;
    const shiftCorrection = shifted ? POINT_OVERLAY_PADDING : 0;

    const shapes = useMemo(
      () => ({
        shapeRefs: new Map<string, MutableRefObject<CanvasShape>>(),
      }),
      [],
    );

    return (
      <CanvasContext.Provider value={shapes}>
        <div className={plotStyles}>
          <Canvas
            ref={canvasRefs}
            width={width + shiftCorrection}
            height={height + shiftCorrection}
          >
            {children}
          </Canvas>
        </div>
      </CanvasContext.Provider>
    );
  },
);
